import { isRouteErrorResponse, Link as RouterLink, useRouteError } from 'react-router-dom';

// material-ui
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function isChunkLoadError(error) {
  const message = String(error?.message || error || '');
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('Loading chunk') ||
    message.includes('dynamically imported module')
  );
}

function routeErrorMessage(error) {
  if (isChunkLoadError(error)) {
    return {
      title: '새 버전 화면을 불러오지 못했습니다.',
      description: '사이트가 갱신되는 동안 이전 화면 파일을 요청했습니다. 새로고침하면 최신 화면으로 다시 연결됩니다.',
      action: '새로고침'
    };
  }

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return {
        title: '페이지를 찾을 수 없습니다.',
        description: '주소가 바뀌었거나 더 이상 제공되지 않는 화면입니다.',
        action: '홈으로 이동'
      };
    }

    if (error.status === 401 || error.status === 403) {
      return {
        title: '접근 권한이 없습니다.',
        description: '로그인이 필요하거나 현재 계정으로 접근할 수 없는 화면입니다.',
        action: '로그인으로 이동'
      };
    }
  }

  return {
    title: '화면을 불러오는 중 문제가 발생했습니다.',
    description: '잠시 후 다시 시도해 주세요. 문제가 계속되면 관리자에게 문의해 주세요.',
    action: '새로고침'
  };
}

export default function AppRouteError() {
  const error = useRouteError();
  const message = routeErrorMessage(error);
  const shouldReload = message.action === '새로고침';
  const targetPath = message.action === '로그인으로 이동' ? '/login' : '/';

  return (
    <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', py: 4 }}>
      <Paper variant="outlined" sx={{ width: 1, p: { xs: 3, sm: 4 }, borderRadius: 2 }}>
        <Stack spacing={2.5}>
          <Stack spacing={1}>
            <Typography variant="h3">{message.title}</Typography>
            <Typography variant="body1" color="text.secondary">
              {message.description}
            </Typography>
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25}>
            <Button
              variant="contained"
              onClick={shouldReload ? () => window.location.reload() : undefined}
              component={shouldReload ? 'button' : RouterLink}
              to={shouldReload ? undefined : targetPath}
            >
              {message.action}
            </Button>
            <Button variant="outlined" component={RouterLink} to="/">
              홈
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  );
}
